import React, { useState } from 'react';
import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import WebAssetOffIcon from '@mui/icons-material/WebAssetOff';
import { FormattedMessage } from 'react-intl';
import { DigitalQuestion } from '../../../redux/types';
import GenericDialog from '../../GenericDialog';

type Props = {
  questions: DigitalQuestion[];
  selectedQuestion?: DigitalQuestion;
  setSelectedQuestion?: (q?: DigitalQuestion) => void;
  dialog?: React.ReactNode;
};

const QuestionCollapsed: React.FC<Props> = ({
  questions,
  selectedQuestion,
  dialog,
  setSelectedQuestion,
}: Props) => {
  const onQuestionClick = (q?: DigitalQuestion) => {
    if (setSelectedQuestion) {
      setSelectedQuestion(q);
    }
  };
  const onQuestionClose = () => {
    if (setSelectedQuestion) {
      setSelectedQuestion(undefined);
    }
  };
  return (
    <Box>
      <List>
        {
            questions.map((q) => (
              <React.Fragment key={q.id}>
                <ListItem
                  disablePadding={!!dialog}
                  secondaryAction={(
                    <Box display="flex" gap={1} alignItems="center">
                      {
                        q.hideAggregation && (
                          <Tooltip title={<FormattedMessage id="questionEditor.hideAggregationTooltip" />}>
                            <WebAssetOffIcon fontSize="medium" sx={{ color: 'grey.500' }} />
                          </Tooltip>
                        )
                      }
                      <Chip label={q.type} />
                    </Box>
                  )}
                >
                  {
                    dialog && (
                      <ListItemButton sx={{ p: 2 }} onClick={() => onQuestionClick(q)}>
                        <ListItemText primary={q.text} />
                      </ListItemButton>
                    )
                  }
                  {
                    !dialog && (
                      <ListItemText primary={q.text} />
                    )
                  }
                </ListItem>
                <Divider />
              </React.Fragment>
            ))
          }
      </List>
      <GenericDialog
        isOpen={!!selectedQuestion}
        onClose={onQuestionClose}
        onRequestClose={onQuestionClose}
      >
        {
          dialog
        }
      </GenericDialog>
    </Box>
  );
};

export default QuestionCollapsed;
